import { createRoot } from 'react-dom/client'
import './index.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'

// Lazy load heavy components
const App = lazy(() => import('./App.tsx'))
const Dashboard = lazy(() => import('./pages/Dashboard.tsx'))
const AuthPage = lazy(() => import('./pages/AuthPage'))
const LandingPage = lazy(() => import('./pages/LandingPage'))
const InvitePage = lazy(() => import('./pages/InvitePage'))
const AdminPanel = lazy(() => import('./pages/AdminPanel'))
const AdminDebug = lazy(() => import('./pages/AdminDebug'))
const DatabaseTestPage = lazy(() => import('./pages/DatabaseTestPage'))
import { AuthProvider } from './contexts/AuthContext'
import { ModeProvider } from './contexts/ModeContext'

const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
  </div>
)

createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <ModeProvider>
      <BrowserRouter>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/app" element={<App />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/invite/:token" element={<InvitePage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/admin-debug" element={<AdminDebug />} />
            <Route path="/admin/database" element={<DatabaseTestPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ModeProvider>
  </AuthProvider>
);
